import React from 'react';
import { List, Divider, Drawer, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import TimelineIcon from '@mui/icons-material/Timeline';
import PaymentIcon from '@mui/icons-material/Payment';
import DashboardNavItem from './DashboardNavItem';

interface DashboardNavProps {
  drawerWidth: number;
}

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '' },
  { text: 'Trends', icon: <TimelineIcon />, path: 'trends' },
  { text: 'Organizations', icon: <BusinessIcon />, path: 'organizations' },
  { text: 'Users', icon: <GroupIcon />, path: 'users' },
  { text: 'Billing', icon: <PaymentIcon />, path: 'billing' },
];

const DashboardNav: React.FC<DashboardNavProps> = ({ drawerWidth }) => {
  const handleLinkClick = (path: string) => {
    console.log(`[DashboardNav] Desktop link clicked. Relative path: ${path || 'index'}`);
  };

  const drawerContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Divider />
      <List sx={{ flexGrow: 1 }}>
        {menuItems.map(item => (
          <DashboardNavItem key={item.text} item={item} onClick={handleLinkClick} />
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="dashboard sections"
    >
      {/* Permanent Desktop Drawer - Only renders on md and up */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            position: 'relative',
            height: '100%',
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default DashboardNav;
